import { IEnvironment } from "./environment";

export const stagingEnv: IEnvironment = {
  env: "staging",
  api: {
    protocol: "https",
    host: "aurora-api.apps.ocp11.topnet.rs",
  },
  chatAssistantAllowedUserIds: [41],
};
